import React from 'react'
import './about.css'
import ME from '../../assets/header1.png'
import { BsAward } from 'react-icons/bs'
import { FiUsers } from 'react-icons/fi'
import { AiOutlineFolderOpen } from 'react-icons/ai'

const About = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        
        <div className="about__content">
          <div className="about__cards">
            <article className='about_card'>
              <BsAward className='about__icon' />
              <h5>Education</h5>
              <small><i>PG in Cloud Architecture </i></small>
              <small><i>& B.E in Computer Science</i></small>
            </article>

            <article className='about_card'>
              <FiUsers className='about__icon' />
              <h5>Experience</h5>
              <small><i>5+ years in Software Development</i></small>
            </article>

            <article className='about_card'>
              <AiOutlineFolderOpen className='about__icon' />
              <h5>Projects</h5>
              <small><i>20+ Completed</i></small>
            </article>
          </div>

          <p>
            I am a Computer Science Engineer specializing in backend development and cloud-based infrastructure. I combine strong theoretical foundations with hands-on experience building scalable web applications and deploying production-ready environments using AWS, Azure, and Terraform.
          </p>
          <a href='#contact' className='btn btn-primary'>Contact</a>

        </div>

        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt='About Image' />
          </div>
        </div>
      </div>

    </section>
  )
}

export default About